module.exports = __webpack_public_path__ + "img/vehiclePlaceholder.4e1cadbf.jpg";